export default __webpack_public_path__ + "static/media/img-600x400-4.c44a31de.jpg";